<template>
    <div
            :is="driver + '-form'"
            v-model="data"
            :errors="errors"
    />
</template>

<script>
    import CompanySubscriptionsForm
        from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/CompanySubscriptions'
    import ConstantForm from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/Constant'
    import GoogleAnalyticsForm
        from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/GoogleAnalytics'
    import MagazineRecipientsForm
        from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/MagazineRecipients'
    import MailchimpSubscribersForm
        from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/MailchimpSubscribers'
    import PersonSubscriptionsForm
        from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/PersonSubscriptions'
    import PortalForm from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/Portal'

    export default {
        components: {
            CompanySubscriptionsForm,
            ConstantForm,
            GoogleAnalyticsForm,
            MagazineRecipientsForm,
            MailchimpSubscribersForm,
            PersonSubscriptionsForm,
            PortalForm
        },

        props: {
            driver: {
                required: true
            },

            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
